"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classUtils = void 0;

var _ = require("lodash");

exports.classUtils = {
  // This is useful for classes that have nested methods. Nested methods don't get bound out of the box.
  bindAll: function bindAll(self) {
    var exclude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['contructor'];
    var thisArg = arguments.length > 2 ? arguments[2] : undefined;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Object.getOwnPropertyNames(self)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;
        var val = self[key];

        if (!_.includes(exclude, key)) {
          if (_.isFunction(val)) {
            self[key] = val.bind(thisArg || self);
          } else if (_.isObject(val)) {
            exports.classUtils.bindAll(val, exclude, self);
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return self;
  }
};